(ns frontend.ui.component.lp-portal.report.body.innovestor.fund.controller
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.utils :as fu]
   [frontend.ui.component.lp-portal.report.body.invest-europe.holding.controller :refer [block-table-raw-data->editable-data
                                                                                         invest-europe-editable-data->raw-data
                                                                                         invest-europe-table-raw-data->editable-data]]))

(defn ->ui-data
  [{:keys [dynamic-data report-data] :as props}]
  {:fund-name        (:fund-name report-data)
   :reference-date   (get-in report-data [:reference-date])
   :reporting-period (:reporting-period report-data)
   :team-letter      {:letter-text           (report-ctl/rich-content
                                              props
                                              :letter-text)
                      :letter-text-2         (report-ctl/rich-content
                                              props
                                              :letter-text-2)
                      :letter-text-finnish   (report-ctl/rich-content
                                              props
                                              :letter-text-finnish)
                      :letter-text-2-finnish (report-ctl/rich-content
                                              props
                                              :letter-text-2-finnish)
                      :letter-image          (report-ctl/image-content
                                              props
                                              :letter-image-footnotes
                                              (:letter-image dynamic-data))}
   :fund-overview    {:fund-overview-1     (->> (report-ctl/with-footnote
                                                  props
                                                  :fund-overview-footnotes
                                                  (:fund-overview-1 report-data))
                                                (report-ctl/with-editable-tables
                                                  (merge {:fixed-columns? true :fixed-labels? true} props)
                                                  :fund-overview-1
                                                  block-table-raw-data->editable-data
                                                  invest-europe-editable-data->raw-data))
                      :case-overview       (report-ctl/rich-content
                                            props
                                            :case-overview-text)
                      :fund-overview-image (report-ctl/image-content
                                            props
                                            :fund-overview-image-footnotes
                                            (:fund-overview-image dynamic-data))}
   :esg              {:esg-summary (report-ctl/rich-content
                                    props
                                    :esg-summary-text)
                      :esg-image   (report-ctl/image-content
                                    props
                                    :esg-image-footnotes
                                    (:esg-image dynamic-data))}
   :fund-status      {:net-asset-value (->> (report-ctl/with-footnote
                                              props
                                              :net-asset-value-footnotes
                                              (:net-asset-value report-data))
                                            (report-ctl/with-editable-tables
                                              props :net-asset-value
                                              invest-europe-table-raw-data->editable-data
                                              invest-europe-editable-data->raw-data))
                      :key-metrics (->> (report-ctl/with-footnote
                                          props
                                          :key-metrics-footnotes
                                          (:key-metrics report-data))
                                        (report-ctl/with-editable-tables
                                          props :key-metrics
                                          invest-europe-table-raw-data->editable-data
                                          invest-europe-editable-data->raw-data))
                      :fund-status-image (report-ctl/image-content
                                          props
                                          :fund-status-image-footnotes
                                          (:fund-status-image dynamic-data))
                      :fund-status-summary (report-ctl/rich-content
                                            props
                                            :fund-status-summary-text)
                      :management-fees (->> (report-ctl/with-footnote
                                              props
                                              :management-fees-footnotes
                                              (:management-fees report-data))
                                            (report-ctl/with-editable-tables
                                              props :management-fees
                                              invest-europe-table-raw-data->editable-data
                                              invest-europe-editable-data->raw-data))
                      :transaction-and-other-fees (->> (report-ctl/with-footnote
                                                         props
                                                         :transaction-and-other-fees-footnotes
                                                         (:transaction-and-other-fees report-data))
                                                       (report-ctl/with-editable-tables
                                                         props :transaction-and-other-fees
                                                         invest-europe-table-raw-data->editable-data
                                                         invest-europe-editable-data->raw-data))
                      :carried-interest (->> (report-ctl/with-footnote
                                               props
                                               :carried-interest-footnotes
                                               (:carried-interest report-data))
                                             (report-ctl/with-editable-tables
                                               props :carried-interest
                                               invest-europe-table-raw-data->editable-data
                                               invest-europe-editable-data->raw-data))
                      :fund-operating-expenses (->> (report-ctl/with-footnote
                                                      props
                                                      :fund-operating-expenses-footnotes
                                                      (:fund-operating-expenses report-data))
                                                    (report-ctl/with-editable-tables
                                                      props :fund-operating-expenses
                                                      invest-europe-table-raw-data->editable-data
                                                      invest-europe-editable-data->raw-data))
                      :capital-account-year-to-date (->> (report-ctl/with-footnote
                                                           props
                                                           :capital-account-year-to-date-footnotes
                                                           (:capital-account-year-to-date report-data))
                                                         (report-ctl/with-editable-tables
                                                           props :capital-account-year-to-date
                                                           invest-europe-table-raw-data->editable-data
                                                           invest-europe-editable-data->raw-data))
                      :capital-account-since-inception (->> (report-ctl/with-footnote
                                                              props
                                                              :capital-account-since-inception-footnotes
                                                              (:capital-account-since-inception report-data))
                                                            (report-ctl/with-editable-tables
                                                              props :capital-account-since-inception
                                                              invest-europe-table-raw-data->editable-data
                                                              invest-europe-editable-data->raw-data))}
   :portfolio-information {:portfolio-summary (->> (report-ctl/with-footnote
                                                     props
                                                     :portfolio-summary-footnotes
                                                     (:portfolio-summary report-data))
                                                   (report-ctl/with-editable-tables
                                                     props :portfolio-summary
                                                     invest-europe-table-raw-data->editable-data
                                                     invest-europe-editable-data->raw-data))}})

(defn ->feeder-ui-data
  [{:keys [dynamic-data report-data] :as props}]
  {:fund-name        (:fund-name report-data)
   :reference-date   (get-in report-data [:reference-date])
   :reporting-period (:reporting-period report-data)
   :fund-overview    {:fund-overview-1     (->> (report-ctl/with-footnote
                                                  props
                                                  :fund-overview-footnotes
                                                  (:fund-overview-1 report-data))
                                                (report-ctl/with-editable-tables
                                                  (merge {:fixed-columns? true :fixed-labels? true} props)
                                                  :fund-overview-1
                                                  block-table-raw-data->editable-data
                                                  invest-europe-editable-data->raw-data))
                      :case-overview       (report-ctl/rich-content
                                            props
                                            :case-overview-text)
                      :fund-overview-image (report-ctl/image-content
                                            props
                                            :fund-overview-image-footnotes
                                            (:fund-overview-image dynamic-data))}
   :fund-status      {:net-asset-value (->> (report-ctl/with-footnote
                                              props
                                              :net-asset-value-footnotes
                                              (:net-asset-value report-data))
                                            (report-ctl/with-editable-tables
                                              props :net-asset-value
                                              invest-europe-table-raw-data->editable-data
                                              invest-europe-editable-data->raw-data))
                      :key-metrics (->> (report-ctl/with-footnote
                                          props
                                          :key-metrics-footnotes
                                          (:key-metrics report-data))
                                        (report-ctl/with-editable-tables
                                          props :key-metrics
                                          invest-europe-table-raw-data->editable-data
                                          invest-europe-editable-data->raw-data))
                      :capital-account-year-to-date (->> (report-ctl/with-footnote
                                                           props
                                                           :capital-account-year-to-date-footnotes
                                                           (:capital-account-year-to-date report-data))
                                                         (report-ctl/with-editable-tables
                                                           props :capital-account-year-to-date
                                                           invest-europe-table-raw-data->editable-data
                                                           invest-europe-editable-data->raw-data))
                      :capital-account-since-inception (->> (report-ctl/with-footnote
                                                              props
                                                              :capital-account-since-inception-footnotes
                                                              (:capital-account-since-inception report-data))
                                                            (report-ctl/with-editable-tables
                                                              props :capital-account-since-inception
                                                              invest-europe-table-raw-data->editable-data
                                                              invest-europe-editable-data->raw-data))}})

(defn split-fund-overview-row-data
  [data column]
  (let [rows (:rows data)
        split (split-with (fn [row]
                            (let [row-first-value (first (:row-data row))]
                              (not= (fu/trimmed-lower-case row-first-value)
                                    "investment focus by"))) rows)
        new-data (case column
                   1 (assoc data :rows (vec (first split)))
                   2 (assoc data :rows (vec (second split)))
                   data)]
    new-data))

(defn with-split-fund-overview
  [table-data column]
  (if (:figures table-data)
    (assoc table-data
           :figures
           (split-fund-overview-row-data (:figures table-data) column))
    table-data))

(defn fund-overview
  [{:keys [props report-data table-key column]}]
  (let [table-data (->> (report-ctl/with-footnote
                          props
                          :fund-overview-footnotes
                          (:fund-overview-1 report-data))
                        (report-ctl/with-editable-tables
                          (merge {:fixed-columns? true
                                  :fixed-labels? true
                                  :disable-heading-edit? true} props)
                          table-key
                          block-table-raw-data->editable-data
                          invest-europe-editable-data->raw-data))]
    (with-split-fund-overview table-data column)))

(defn ->tech-ui-data
  [{:keys [dynamic-data report-data] :as props}]
  (let [fund-overview-1 (fund-overview {:props       props
                                        :report-data report-data
                                        :table-key   :fund-overview-1
                                        :column      1})
        fund-overview-2 (fund-overview {:props       props
                                        :report-data report-data
                                        :table-key   :fund-overview-2
                                        :column      2})]
    {:fund-name             (:fund-name report-data)
     :reference-date        (get-in report-data [:reference-date])
     :reporting-period      (:reporting-period report-data)
     :team-letter           {:letter-text           (report-ctl/rich-content
                                                     props
                                                     :letter-text)
                             :letter-text-2         (report-ctl/rich-content
                                                     props
                                                     :letter-text-2)
                             :letter-text-finnish   (report-ctl/rich-content
                                                     props
                                                     :letter-text-finnish)
                             :letter-text-2-finnish (report-ctl/rich-content
                                                     props
                                                     :letter-text-2-finnish)
                             :letter-image          (report-ctl/image-content
                                                     props
                                                     :letter-image-footnotes
                                                     (:letter-image dynamic-data))}
     :fund-overview         {:fund-overview-1     fund-overview-1
                             :fund-overview-2     fund-overview-2
                             :case-overview       (report-ctl/rich-content
                                                   props
                                                   :case-overview-text)
                             :fund-overview-image (report-ctl/image-content
                                                   props
                                                   :fund-overview-image-footnotes
                                                   (:fund-overview-image dynamic-data))} 
   :fund-status           {:net-asset-value (->> (report-ctl/with-footnote
                                                   props
                                                   :net-asset-value-footnotes
                                                   (:net-asset-value report-data))
                                                 (report-ctl/with-editable-tables
                                                   props :net-asset-value
                                                   invest-europe-table-raw-data->editable-data
                                                   invest-europe-editable-data->raw-data))
                           :key-metrics (->> (report-ctl/with-footnote
                                               props
                                               :key-metrics-footnotes
                                               (:key-metrics report-data))
                                             (report-ctl/with-editable-tables
                                               props :key-metrics
                                               invest-europe-table-raw-data->editable-data
                                               invest-europe-editable-data->raw-data))
                           :fund-status-image (report-ctl/image-content
                                               props
                                               :fund-status-image-footnotes
                                               (:fund-status-image dynamic-data))
                           :fund-status-summary (report-ctl/rich-content
                                                 props
                                                 :fund-status-summary-text)
                           :management-fees (->> (report-ctl/with-footnote
                                                   props
                                                   :management-fees-footnotes
                                                   (:management-fees report-data))
                                                 (report-ctl/with-editable-tables
                                                   props :management-fees
                                                   invest-europe-table-raw-data->editable-data
                                                   invest-europe-editable-data->raw-data))
                           :transaction-and-other-fees (->> (report-ctl/with-footnote
                                                              props
                                                              :transaction-and-other-fees-footnotes
                                                              (:transaction-and-other-fees report-data))
                                                            (report-ctl/with-editable-tables
                                                              props :transaction-and-other-fees
                                                              invest-europe-table-raw-data->editable-data
                                                              invest-europe-editable-data->raw-data))
                           :carried-interest (->> (report-ctl/with-footnote
                                                    props
                                                    :carried-interest-footnotes
                                                    (:carried-interest report-data))
                                                  (report-ctl/with-editable-tables
                                                    props :carried-interest
                                                    invest-europe-table-raw-data->editable-data
                                                    invest-europe-editable-data->raw-data))
                           :fund-operating-expenses (->> (report-ctl/with-footnote
                                                           props
                                                           :fund-operating-expenses-footnotes
                                                           (:fund-operating-expenses report-data))
                                                         (report-ctl/with-editable-tables
                                                           props :fund-operating-expenses
                                                           invest-europe-table-raw-data->editable-data
                                                           invest-europe-editable-data->raw-data))
                           :capital-account-year-to-date (->> (report-ctl/with-footnote
                                                                props
                                                                :capital-account-year-to-date-footnotes
                                                                (:capital-account-year-to-date report-data))
                                                              (report-ctl/with-editable-tables
                                                                props :capital-account-year-to-date
                                                                invest-europe-table-raw-data->editable-data
                                                                invest-europe-editable-data->raw-data))
                           :capital-account-since-inception (->> (report-ctl/with-footnote
                                                                   props
                                                                   :capital-account-since-inception-footnotes
                                                                   (:capital-account-since-inception report-data))
                                                                 (report-ctl/with-editable-tables
                                                                   props :capital-account-since-inception
                                                                   invest-europe-table-raw-data->editable-data
                                                                   invest-europe-editable-data->raw-data))}
     :portfolio-information {:portfolio-summary (->> (report-ctl/with-footnote
                                                       props
                                                       :portfolio-summary-footnotes
                                                       (:portfolio-summary report-data))
                                                     (report-ctl/with-editable-tables
                                                       props :portfolio-summary
                                                       invest-europe-table-raw-data->editable-data
                                                       invest-europe-editable-data->raw-data))}}))
